module.exports = __webpack_public_path__ + "static/img/sunset.7c5b1e93.jpeg";